import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import $ from 'jquery';
import { API_DOMAIN } from './globals'; // Import the global domain name

function BBB() {

    const [UserType, setUserType] = useState("");
    const [UserName, setUserName] = useState("");

    const [Team1Amt, setTeam1Amt] = useState("");
    const [Team2Amt, setTeam2Amt] = useState("");
    const [Team3Amt, setTeam3Amt] = useState("");
    const [Team4Amt, setTeam4Amt] = useState("");
    const [Team5Amt, setTeam5Amt] = useState("");
    const [Team6Amt, setTeam6Amt] = useState("");
    const [Team7Amt, setTeam7Amt] = useState("");
    const [Team8Amt, setTeam8Amt] = useState("");
    const [Team9Amt, setTeam9Amt] = useState("");
    const [Team10Amt, setTeam10Amt] = useState("");
    
    const [BBBBets, setBBBBets] = useState([]);
    const [LastResult, setLastResult] = useState([]);
    const [BetChk, setBetChk] = useState(true);

    const handleCancelClick = () => {
        document.getElementById("betSlipBoxSession").style.display = "none";
        document.getElementById("betSlipBoxSessionMob").style.display = "none";
    };

    const handlePlaceBet = () => {
        PlaceBBBBet();
    };

    function getBBBResult() {
        const param1 = sessionStorage.getItem("UserType");
        const param2 = sessionStorage.getItem("UserName");

        const params = { ut: param1, un: param2 };

        const queryString = new URLSearchParams(params).toString();
        const url = `${API_DOMAIN}/api/Client/getBBBResult.php?${queryString}`;

        fetch(url, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if (data.Status == "Error") {
                    sessionStorage.setItem("LogoutMsg", data.Message)
                    window.location = '/';
                } else {
                    setLastResult(data.data);
                    var UsedCoins = data.data[0].UsedCoins;
                    $("#TotalCoins").html(data.data[0].TotalCoins - data.data[0].UsedCoins);
                    $("#UsedCoins").html(UsedCoins);
                    $("#TotalCoinsMob").html(data.data[0].TotalCoins - data.data[0].UsedCoins);
                    $("#UsedCoinsMob").html(UsedCoins);
                }
            })
            .catch(err => {

            });
    }

    function PlaceBBBBet() {
        const matchMinAmount = parseFloat(document.getElementById("MatchMinAmount").value);
        const matchMaxAmount = parseFloat(document.getElementById("MatchMaxAmount").value);
        const notificationType = "Match Bet";
        let response = "";

        const windowWidth = window.innerWidth;
        let betAmount = windowWidth >= 500
            ? parseFloat(document.getElementById("MatchAmount").value)
            : parseFloat(document.getElementById("MatchAmountMob").value);

        if (windowWidth >= 500) {
            document.getElementById("cmdDone").disabled = true;
        } else {
            document.getElementById("cmdDoneMob").disabled = true;
        }

        const modal = document.getElementById("myModal");
        if (modal) modal.style.display = "none"; // Hide the modal

        if (!isNaN(betAmount)) {
            if (betAmount >= matchMinAmount && betAmount <= matchMaxAmount) {
                const betRate = document.getElementById("MatchRate").value;
                const betMode = document.getElementById("MatchBetChk").value;
                const betTeam = document.getElementById("MatchTeam").value;
                const matchCode = document.getElementById("RoundID").innerHTML;
                const matchBetChk = document.getElementById("MatchBetChk").value;
                const matchType = "Lucky7";
                const userType = document.getElementById("UserType").value;
                const userName = document.getElementById("UserName").value;

                const teamKRate = document.getElementById("TeamKRate").value;
                const teamLRate = document.getElementById("TeamLRate").value;
                const bst = document.getElementById("ServerTime_Select").value;
                const bpt = document.getElementById("ServerTime_Formatted").value;
                const id = document.getElementById("BetTeamindex").value;

                console.log("id="+id+", TeamKRate="+$("#TeamKRate").val()+", KRate="+$("#KRate"+id).val()+", betMode="+betMode);

                //if (($("#TeamKRate").val() == $("#KRate" + id).html()) && betMode!="") {
                    const url = `${API_DOMAIN}/PlaceBBBBet.php?BetRate=${betRate}&BetAmount=${betAmount}&BetMode=${betMode}&BetTeam=${betTeam}&MatchCode=${matchCode}&MatchBetChk=${matchBetChk}&MatchType=${matchType}&BetType=${"Match Bet"}&TeamKRate=${teamKRate}&TeamLRate=${teamLRate}&BST=${bst}&BPT=${bpt}&ut=${userType}&un=${userName}`;

                    fetch(url, {
                        method: 'GET',
                        credentials: 'include', // Equivalent to withCredentials:true
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })
                        .then(response => response.json())
                        .then(data => {
                            if (data.Status === "Success") {
                                document.getElementById("TotalCoins").innerHTML = data.TotalCoins - data.UsedCoins;
                                document.getElementById("UsedCoins").innerHTML = data.UsedCoins;

                                document.getElementById("TotalCoinsMob").innerHTML = data.TotalCoins - data.UsedCoins;
                                document.getElementById("UsedCoinsMob").innerHTML = data.UsedCoins;

                                sessionStorage.setItem('Coins', data.TotalCoins);
                                sessionStorage.setItem('Exposure', data.UsedCoins);

                                setTeam1Amt(data.Team1Amt);
                                setTeam2Amt(data.Team2Amt);
                                setTeam3Amt(data.Team3Amt);
                                setTeam4Amt(data.Team4Amt);
                                setTeam5Amt(data.Team5Amt);
                                setTeam6Amt(data.Team6Amt);
                                setTeam7Amt(data.Team7Amt);
                                setTeam8Amt(data.Team8Amt);
                                setTeam9Amt(data.Team9Amt);
                                setTeam10Amt(data.Team10Amt);

                                setBBBBets((prevBets) => [data.BetDetails[0], ...prevBets]);

                                response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                                            <div class="message-content success">
                                                <i class="component-icon-wrap icon-success"></i>
                                                <p>Bet Successful</p>
                                            </div>
                                        </div>`;
                            } else {
                                response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                                            <div class="message-content error">
                                                <i class="component-icon-wrap icon-error"></i>
                                                <p>${data.Message}</p>
                                            </div>
                                        </div>`;
                            }
                            document.getElementById("BetResponse").innerHTML = response;
                            setTimeout(() => { document.getElementById("BetResponse").innerHTML = ""; }, 3000);
                            ;
                            $("#betSlipBoxSession").css('display', 'none');
                            $("#betSlipBoxSessionMob").css('display', 'none');
                        });
                // } else {
                //     response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                //                 <div class="message-content error">
                //                     <i class="component-icon-wrap icon-error"></i>
                //                     <p>Bet Rejected. Rate Has Been Changed</p>
                //                 </div>
                //             </div>`;
                //     document.getElementById("BetResponse").innerHTML = response;
                //     $("#betSlipBoxSession").css('display', 'none');
                //     $("#betSlipBoxSessionMob").css('display', 'none');
                //     setTimeout(() => { document.getElementById("BetResponse").innerHTML = ""; }, 3000);
                    
                // }
            } else {
                response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                            <div class="message-content error">
                                <i class="component-icon-wrap icon-error"></i>
                                <p>${betAmount < matchMinAmount ? `Minimum Bet Amount is ${matchMinAmount}` : `Maximum Bet Amount is ${matchMaxAmount}`}</p>
                            </div>
                        </div>`;
                document.getElementById("BetResponse").innerHTML = response;
                $("#betSlipBoxSession").css('display', 'none');
                $("#betSlipBoxSessionMob").css('display', 'none');
                setTimeout(() => { document.getElementById("BetResponse").innerHTML = ""; }, 3000);
            }
        } else {
            response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                        <div class="message-content error">
                            <i class="component-icon-wrap icon-error"></i>
                            <p>Invalid Amount ${betAmount}</p>
                        </div>
                    </div>`;
            document.getElementById("BetResponse").innerHTML = response;
            $("#betSlipBoxSession").css('display', 'none');
            $("#betSlipBoxSessionMob").css('display', 'none');
            setTimeout(() => { document.getElementById("BetResponse").innerHTML = ""; }, 3000);
        }
    }

    $(document).on('click', '.casinoBet', function (e) {
        //fadeOutReset();
        console.log("BetChk=" + BetChk);
        if (BetChk == true) {
            var rateVal = $(this).attr('rt');
            var betOn = $(this).attr('betOn');
            var gameId = $("#market_id").val();
            var betType = $(this).attr('bt');

            console.log("rateVal=" + rateVal + ", betType=" + betType + ", betOn=" + betOn);

            var player = "";
            var betTypeText = "";

            if (rateVal > 0) {

                if (betOn == 1) {
                    player = "0 Runs";
                } else if (betOn == 2) {
                    player = "1 Runs";
                } else if (betOn == 3) {
                    player = "2 Runs";
                } else if (betOn == 4) {
                    player = "3 Runs";
                } else if (betOn == 5) {
                    player = "4 Runs";
                } else if (betOn == 6) {
                    player = "6 Runs";
                } else if (betOn == 7) {
                    player = "Boundry";
                } else if (betOn == 8) {
                    player = "Wicket";
                } else if (betOn == 9) {
                    player = "Extra Runs";
                }

                if (betType == 0) {
                    betTypeText = "Back";
                    $("#MatchBetChk").val("K");
                    $("#betBoxColor").css('background-color', 'rgb(114, 187, 239)');
                    $("#betBoxColorMob").css('background-color', 'rgb(114, 187, 239)');
                } 
                // else if (betType == 1) {
                //     betTypeText = "Lay";
                //     $("#MatchBetChk").val("L");
                //     $("#betBoxColor").css('background-color', 'rgb(250, 169, 186)');
                //     $("#betBoxColorMob").css('background-color', 'rgb(250, 169, 186)');
                // }

                $("#BetTeamindex").val($(this).attr('sr'));
                $("#MatchTeam").val(player);
                $("#MatchRate").val(rateVal);

                $("#DisplayBhavName").html(player);
                $("#Rate1_Odds").val(rateVal);

                //console.log("KRate="+$("#KRate"+betOn).attr("rt"));
                $("#TeamKRate").val($("#KRate" + $("#BetTeamindex").val()).html());
                $("#TeamLRate").val($("#LRate" + $("#BetTeamindex").val()).html());
                $("#ServerTime_Select").val($("#ServerTime_Formatted").val());

                $("#modalTitle").html("Ball By Ball - " + player);
                $("#modalRate").html(rateVal);
                $("#betOnModal").val(betOn);
                $("#betTypeModal").val(betType);
                $("#rateValModal").val(rateVal);
                $("#gameId").val(gameId);

                //console.log("rateVal=" + rateVal + ", betOn=" + betOn + ", betType=" + betType + ", player=" + player)
                var $window = $(window);
                var windowsize = $window.width();
                //console.log(windowsize);
                if (windowsize >= 500) {
                    console.log("Lap");
                    $("#betSlipBoxSession").css('display', 'block');
                    $("#DisplayBhavName").html(player);
                    $("#Rate1_Odds").val(rateVal);
                    document.getElementById("cmdDone").disabled = false;
                    // document.getElementById("cmdDone").style.visibility = "visible";
                    document.getElementById("MatchAmount").value = "";
                    document.getElementById("MatchAmount").readOnly = false;
                    $("#betBoxColor").css('background-color', 'rgb(250, 169, 186)');
                } else {
                    console.log("Mob");
                    $("#betSlipBoxSessionMob").css('display', 'block');
                    $("#DisplayBhavNameMob").html(player);
                    $("#Rate1_OddsMob").val(rateVal);
                    document.getElementById("cmdDoneMob").disabled = false;
                    // document.getElementById("cmdDoneMob").style.visibility = "visible";
                    document.getElementById("MatchAmountMob").value = "";
                    document.getElementById("MatchAmountMob").readOnly = false;
                    $("#betBoxColorMob").css('background-color', 'rgb(250, 169, 186)');
                }
            }
        }
    });

    var ClearTable = true;
    var DisplayResult = false;
    var MarketID_Old = "";

    function getBhavData() {

        $.get(`${API_DOMAIN}/api/odds/Casino/BBB.php`, function (data) {

            var ServerTime = "";

            var t = data.ServerTime.split(/[- :]/);
            var d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
            ServerTime = Date.parse(d);

            var myDate = d;
            var ServerTime_Formatted = myDate.getFullYear() + '-' + ('0' + (myDate.getMonth() + 1)).slice(-2) + '-' + ('0' + myDate.getDate()).slice(-2) + ' ' + myDate.getHours() + ':' + ('0' + (myDate.getMinutes())).slice(-2) + ':' + myDate.getSeconds();
            $("#ServerTime_Formatted").val(ServerTime_Formatted);

            var card1 = '';

            data = (data.BBBData);
            //console.log(data);
            if (data.data.hasOwnProperty('t1') == true) {
                var datas = data.data.t1;
                if (datas !== null) {
                    var timer = datas.lt;
                    var timer1 = 0;
                    var timer2 = 0;

                    if (timer.length == 1) {
                        timer1 = 0;
                        timer2 = timer[0];
                    } else if (timer.length == 2) {
                        timer1 = timer[0];
                        timer2 = timer[1];
                    }

                    $("#RoundID").html(datas.mid);

                    if (datas.rdesc != "") {
                        $("#C1").html('<img class="" src="../images/ball-blank.png" width="60" height="60">');
                        $("#Result").html(datas.rdesc);
                    } else {
                        $("#C1").html("");
                        $("#Result").html("");
                    }
                    
                    $("#Timer").html(timer);
                    //timer=5;
                    if (timer > 3) {

                        $("#KRate1").attr("rt", (datas.sub[0].b - 1).toFixed(2));
                        $("#KRate2").attr("rt", (datas.sub[1].b - 1).toFixed(2));
                        $("#KRate3").attr("rt", (datas.sub[2].b - 1).toFixed(2));
                        $("#KRate4").attr("rt", (datas.sub[3].b - 1).toFixed(2));
                        $("#KRate5").attr("rt", (datas.sub[4].b - 1).toFixed(2));
                        $("#KRate6").attr("rt", (datas.sub[5].b - 1).toFixed(2));
                        $("#KRate7").attr("rt", (datas.sub[6].b - 1).toFixed(2));
                        $("#KRate8").attr("rt", (datas.sub[7].b - 1).toFixed(2));
                        $("#KRate9").attr("rt", (datas.sub[8].b - 1).toFixed(2));

                        $("#divKRate1").attr("rt", (datas.sub[0].b - 1).toFixed(2));
                        $("#divKRate2").attr("rt", (datas.sub[1].b - 1).toFixed(2));
                        $("#divKRate3").attr("rt", (datas.sub[2].b - 1).toFixed(2));
                        $("#divKRate4").attr("rt", (datas.sub[3].b - 1).toFixed(2));
                        $("#divKRate5").attr("rt", (datas.sub[4].b - 1).toFixed(2));
                        $("#divKRate6").attr("rt", (datas.sub[5].b - 1).toFixed(2));
                        $("#divKRate7").attr("rt", (datas.sub[6].b - 1).toFixed(2));
                        $("#divKRate8").attr("rt", (datas.sub[7].b - 1).toFixed(2));
                        $("#divKRate9").attr("rt", (datas.sub[8].b - 1).toFixed(2));

                        $("#KRate1").html((datas.sub[0].b - 1).toFixed(2));
                        $("#KRate2").html((datas.sub[1].b - 1).toFixed(2));
                        $("#KRate3").html((datas.sub[2].b - 1).toFixed(2));
                        $("#KRate4").html((datas.sub[3].b - 1).toFixed(2));
                        $("#KRate5").html((datas.sub[4].b - 1).toFixed(2));
                        $("#KRate6").html((datas.sub[5].b - 1).toFixed(2));
                        $("#KRate7").html((datas.sub[6].b - 1).toFixed(2));
                        $("#KRate8").html((datas.sub[7].b - 1).toFixed(2));
                        $("#KRate9").html((datas.sub[8].b - 1).toFixed(2));

                        $("#KRate1Lock").css("display", "none");
                        $("#KRate2Lock").css("display", "none");
                        $("#KRate3Lock").css("display", "none");
                        $("#KRate4Lock").css("display", "none");
                        $("#KRate5Lock").css("display", "none");
                        $("#KRate6Lock").css("display", "none");
                        $("#KRate7Lock").css("display", "none");
                        $("#KRate8Lock").css("display", "none");
                        $("#KRate9Lock").css("display", "none");

                        setBetChk(true);
                    } else {

                        $("#KRate1").attr("rt", "0.00");
                        $("#KRate2").attr("rt", "0.00");
                        $("#KRate3").attr("rt", "0.00");
                        $("#KRate4").attr("rt", "0.00");
                        $("#KRate5").attr("rt", "0.00");
                        $("#KRate6").attr("rt", "0.00");
                        $("#KRate7").attr("rt", "0.00");
                        $("#KRate8").attr("rt", "0.00");
                        $("#KRate9").attr("rt", "0.00");

                        $("#divKRate1").attr("rt", "0.00");
                        $("#divKRate2").attr("rt", "0.00");
                        $("#divKRate3").attr("rt", "0.00");
                        $("#divKRate4").attr("rt", "0.00");
                        $("#divKRate5").attr("rt", "0.00");
                        $("#divKRate6").attr("rt", "0.00");
                        $("#divKRate7").attr("rt", "0.00");
                        $("#divKRate8").attr("rt", "0.00");
                        $("#divKRate9").attr("rt", "0.00");

                        $("#KRate1").html("0.00");
                        $("#KRate2").html("0.00");
                        $("#KRate3").html("0.00");
                        $("#KRate4").html("0.00");
                        $("#KRate5").html("0.00");
                        $("#KRate6").html("0.00");
                        $("#KRate7").html("0.00");
                        $("#KRate8").html("0.00");
                        $("#KRate9").html("0.00");

                        //console.log("timer="+timer+", KRate1="+parseFloat(datas.sub[0].b)+", LRate1="+parseFloat(oddDataA.l1));

                        $("#KRate1Lock").css("display", "flex");
                        $("#KRate2Lock").css("display", "flex");
                        $("#KRate3Lock").css("display", "flex");
                        $("#KRate4Lock").css("display", "flex");
                        $("#KRate5Lock").css("display", "flex");
                        $("#KRate6Lock").css("display", "flex");
                        $("#KRate7Lock").css("display", "flex");
                        $("#KRate8Lock").css("display", "flex");
                        $("#KRate9Lock").css("display", "flex");

                        setBetChk(false);
                    }

                    console.log("MarketID_Old=" + MarketID_Old + ", MarketID=" + datas.mid);

                    if (datas.mid != MarketID_Old && ClearTable == true) {
                        DisplayResult = true;
                        MarketID_Old = $("#RoundID").html();
                        setBBBBets([]);
                        setTeam1Amt("0");
                        setTeam2Amt("0");
                        setTeam3Amt("0");
                        setTeam4Amt("0");
                        setTeam5Amt("0");
                        setTeam6Amt("0");
                        setTeam7Amt("0");
                        setTeam8Amt("0");
                        setTeam9Amt("0");
                        ClearTable = true;
                    }
                    //console.log("RoundID="+$("#RoundID").html()+", ClearTable="+ClearTable+", DisplayResult="+DisplayResult);

                    if (DisplayResult == true) {
                        DisplayResult = false;
                        setTimeout(function () {
                            getBBBResult();
                        }, 7000);
                    }

                    if (MarketID_Old != datas.mid)
                        MarketID_Old = datas.mid;
                }

            } else {
                console.log("False");
            }
        });

    }

    useEffect(() => {

        setUserType(sessionStorage.getItem("UserType"));
        setUserName(sessionStorage.getItem("UserName"));

        getBBBResult();

        const marketOdsCall = setInterval(() => {
            getBhavData();
        }, 1000);

        return () => clearInterval(marketOdsCall);

    }, []);

    return (
        <>
            <section className="match-content">

                <div className="">
                    <div className="match-box" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white' }}>
                        <div className="mod-header">
                            <div className="select-tv-ico">
                                <span>Ball By Ball </span>
                                <span style={{ float: 'right' }}>RoundId : <span id="RoundID"></span></span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="col-12 col-md-12" style={{ padding: '0px' }}>
                            <iframe className="live-str" src="https://apis.professorji.in/api/casino-streaming/3061" height="400" width="100%" style={{ backgroundColor: 'black' }}></iframe>
                            <button className="rules-btn">
                                <img style={{ width: '20px' }} src="/images/info.png" />
                            </button>
                            <div className="flipclock">
                                <span className="flipclock-t1 fold" id="Timer">0 0</span>
                            </div>
                            <div className="tp-res-box">
                                <div className="col-md-12 col-12 andr-bhar-res-text andarbahar-res">
                                    <div className="container" style={{width:'100px'}}>
                                        <span id="C1"></span>
                                        <div id="Result" style={{color: 'white', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',fontWeight:'bold'}}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mr-left-right lucky7-main" style={{ justifyContent: 'center', padding: '0px' }}>

                        <div className="col-md-12 mobile-tp-border" style={{ display: 'flex', padding: '0px', background: 'rgb(162, 162, 162)', borderColor: 'rgb(0, 0, 0)' }}>
                            <div className="col-md-6 col-6  mobile-tp-text "></div>
                            <div className="col-md-3 col-3  tp-bhav back" style={{ textAlign: 'center', float: 'right' }}>Back</div>
                            {/* <div className="col-md-3 col-3  tp-bhav lay" style={{ textAlign: 'center', float: 'right' }}>Lay</div> */}
                        </div>
                        <div className="col-md-12 mobile-tp-border" style={{ display: 'flex', padding: '0px', background: 'rgb(255, 255, 255)', borderColor: 'rgb(0, 0, 0)' }}>
                            <div className="col-md-6 col-6  mobile-tp-text casino-profit-text" style={{ color: 'black' }}>
                                0 Runs <br></br>
                                <span style={{ color: `${Team1Amt >= 0 ? "green" : "red"}` }} >{Team1Amt}</span>
                            </div>
                            <div className="col-md-3 col-3 tp-bhav back" style={{ textalign: 'center', padding: '0px' }}>
                                <div className="tp-bhav casinoBet" rt="0" betOn="1" bt="0" sr="1" id="divKRate1" style={{ textAlign: 'center', display: 'grid', padding: '0px', minHeight: '50px', }}>
                                    <span id="KRate1" rt="0" style={{ verticalAlign: 'middle' }}>0.00</span>
                                    <div className="susb-bhav" id="KRate1Lock">
                                        <img src="/cards/padlock.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mobile-tp-border" style={{ display: 'flex', padding: '0px', background: 'rgb(255, 255, 255)', color: 'rgb(255, 255, 255)', borderColor: 'rgb(0, 0, 0)' }}>
                            <div className="col-md-6 col-6  mobile-tp-text casino-profit-text" style={{ color: 'black' }}>
                                1 Runs <br></br>
                                <span style={{ color: `${Team2Amt >= 0 ? "green" : "red"}` }} >{Team2Amt}</span>
                            </div>
                            <div className="col-md-3 col-3 tp-bhav back" style={{ textAlign: 'center', padding: '0px' }}>
                                <div className="tp-bhav casinoBet" rt="0" betOn="2" bt="0" sr="2" id="divKRate2" style={{ textAlign: 'center', display: 'grid', padding: '0px', minHeight: '50px' }}>
                                    <span id="KRate2" rt="0">0.00</span>
                                    <div className="susb-bhav" id="KRate2Lock">
                                        <img src="/cards/padlock.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mobile-tp-border" style={{ display: 'flex', padding: '0px', background: 'rgb(255, 255, 255)', color: 'rgb(255, 255, 255)', borderColor: 'rgb(0, 0, 0)' }}>
                            <div className="col-md-6 col-6  mobile-tp-text casino-profit-text" style={{ color: 'black' }}>
                                2 Runs <br></br>
                                <span style={{ color: `${Team3Amt >= 0 ? "green" : "red"}` }} >{Team3Amt}</span>
                            </div>
                            <div className="col-md-3 col-3 tp-bhav back" style={{ textAlign: 'center', padding: '0px' }}>
                                <div className="tp-bhav casinoBet" rt="0" betOn="3" bt="0" sr="3" id="divKRate3" style={{ textAlign: 'center', display: 'grid', padding: '0px', minHeight: '50px' }}>
                                    <span id="KRate3" rt="0">0.00</span>
                                    <div className="susb-bhav" id="KRate3Lock">
                                        <img src="/cards/padlock.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mobile-tp-border" style={{ display: 'flex', padding: '0px', background: 'rgb(255, 255, 255)', color: 'rgb(255, 255, 255)', borderColor: 'rgb(0, 0, 0)' }}>
                            <div className="col-md-6 col-6  mobile-tp-text casino-profit-text" style={{ color: 'black' }}>
                                3 Runs <br></br>
                                <span style={{ color: `${Team4Amt >= 0 ? "green" : "red"}` }} >{Team4Amt}</span>
                            </div>
                            <div className="col-md-3 col-3 tp-bhav back" style={{ textAlign: 'center', padding: '0px' }}>
                                <div className="tp-bhav casinoBet" rt="0" betOn="4" bt="0" sr="4" id="divKRate4" style={{ textAlign: 'center', display: 'grid', padding: '0px', minHeight: '50px' }}>
                                    <span id="KRate4" rt="0">0.00</span>
                                    <div className="susb-bhav" id="KRate4Lock">
                                        <img src="/cards/padlock.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mobile-tp-border" style={{ display: 'flex', padding: '0px', background: 'rgb(255, 255, 255)', color: 'rgb(255, 255, 255)', borderColor: 'rgb(0, 0, 0)' }}>
                            <div className="col-md-6 col-6  mobile-tp-text casino-profit-text" style={{ color: 'black' }}>
                                4 Runs <br></br>
                                <span style={{ color: `${Team5Amt >= 0 ? "green" : "red"}` }} >{Team5Amt}</span>
                            </div>
                            <div className="col-md-3 col-3 tp-bhav back" style={{ textAlign: 'center', padding: '0px' }}>
                                <div className="tp-bhav casinoBet" rt="0" betOn="5" bt="0" sr="5" id="divKRate5" style={{ textAlign: 'center', display: 'grid', padding: '0px', minHeight: '50px' }}>
                                    <span id="KRate5" rt="0">0.00</span>
                                    <div className="susb-bhav" id="KRate5Lock">
                                        <img src="/cards/padlock.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mobile-tp-border" style={{ display: 'flex', padding: '0px', background: 'rgb(255, 255, 255)', color: 'rgb(255, 255, 255)', borderColor: 'rgb(0, 0, 0)' }}>
                            <div className="col-md-6 col-6  mobile-tp-text casino-profit-text" style={{ color: 'black' }}>
                                6 Runs <br></br>
                                <span style={{ color: `${Team6Amt >= 0 ? "green" : "red"}` }} >{Team6Amt}</span>
                            </div>
                            <div className="col-md-3 col-3 tp-bhav back" style={{ textAlign: 'center', padding: '0px' }}>
                                <div className="tp-bhav casinoBet" rt="0" betOn="6" bt="0" sr="6" id="divKRate6" style={{ textAlign: 'center', display: 'grid', padding: '0px', minHeight: '50px' }}>
                                    <span id="KRate6" rt="0">0.00</span>
                                    <div className="susb-bhav" id="KRate6Lock">
                                        <img src="/cards/padlock.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mobile-tp-border" style={{ display: 'flex', padding: '0px', background: 'rgb(255, 255, 255)', color: 'rgb(255, 255, 255)', borderColor: 'rgb(0, 0, 0)' }}>
                            <div className="col-md-6 col-6  mobile-tp-text casino-profit-text" style={{ color: 'black' }}>
                                Boundry <br></br>
                                <span style={{ color: `${Team7Amt >= 0 ? "green" : "red"}` }} >{Team7Amt}</span>
                            </div>
                            <div className="col-md-3 col-3 tp-bhav back" style={{ textAlign: 'center', padding: '0px' }}>
                                <div className="tp-bhav casinoBet" rt="0" betOn="7" bt="0" sr="7" id="divKRate7" style={{ textAlign: 'center', display: 'grid', padding: '0px', minHeight: '50px' }}>
                                    <span id="KRate7" rt="0">0.00</span>
                                    <div className="susb-bhav" id="KRate7Lock">
                                        <img src="/cards/padlock.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mobile-tp-border" style={{ display: 'flex', padding: '0px', background: 'rgb(255, 255, 255)', color: 'rgb(255, 255, 255)', borderColor: 'rgb(0, 0, 0)' }}>
                            <div className="col-md-6 col-6  mobile-tp-text casino-profit-text" style={{ color: 'black' }}>
                                Wicket <br></br>
                                <span style={{ color: `${Team8Amt >= 0 ? "green" : "red"}` }} >{Team8Amt}</span>
                            </div>
                            <div className="col-md-3 col-3 tp-bhav back" style={{ textAlign: 'center', padding: '0px' }}>
                                <div className="tp-bhav casinoBet" rt="0" betOn="8" bt="0" sr="8" id="divKRate8" style={{ textAlign: 'center', display: 'grid', padding: '0px', minHeight: '50px' }}>
                                    <span id="KRate8" rt="0">0.00</span>
                                    <div className="susb-bhav" id="KRate8Lock">
                                        <img src="/cards/padlock.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mobile-tp-border" style={{ display: 'flex', padding: '0px', background: 'rgb(255, 255, 255)', color: 'rgb(255, 255, 255)', borderColor: 'rgb(0, 0, 0)' }}>
                            <div className="col-md-6 col-6  mobile-tp-text casino-profit-text" style={{ color: 'black' }}>
                                Extra Runs <br></br>
                                <span style={{ color: `${Team9Amt >= 0 ? "green" : "red"}` }} >{Team9Amt}</span>
                            </div>
                            <div className="col-md-3 col-3 tp-bhav back" style={{ textAlign: 'center', padding: '0px' }}>
                                <div className="tp-bhav casinoBet" rt="0" betOn="9" bt="0" sr="9" id="divKRate9" style={{ textAlign: 'center', display: 'grid', padding: '0px', minHeight: '50px' }}>
                                    <span id="KRate9" rt="0">0.00</span>
                                    <div className="susb-bhav" id="KRate9Lock">
                                        <img src="/cards/padlock.png" />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    
                    <div style={{ marginLeft: '0px', marginRight: '0px' }}>
                        <div className="table_tittle" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white' }}>
                            <div className="">
                                <div className="select-tv-ico">
                                    <span>Last Result</span>
                                    <span style={{ float: 'right' }}>
                                        <Link style={{ color: 'rgb(255, 255, 255)' }} to="/Dashboard/BBBResult">View All</Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="Result" style={{ color: 'white', backgroundColor: 'rgb(255, 255, 255)', textAlign: 'right', width: '100%' }}>
                            <div>
                                {LastResult.map((row, index) => (
                                    <span
                                        key={index}
                                        className={`game-result ${row.WonBy == '4 Runs' || row.WonBy == '6 Runs' ? 'bg-success' : row.WonBy == 'Wicket' ? 'bg-danger' : row.WonBy == 'Extra Runs' ? 'bg-warning' : 'bg-dark'}`}
                                    >
                                        {row.WonBy == '0 Runs' ? '0' : row.WonBy == '1 Runs' ? '1' : row.WonBy == '2 Runs' ? '2' : row.WonBy == '3 Runs' ? '4' : row.WonBy == '4 Runs' ? '4' : row.WonBy == '6 Runs' ? '6' : row.WonBy == 'Boundry' ? 'B' : row.WonBy == 'Wicket' ? 'W' : 'ER'}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                
                <input name="MatchCode" type="hidden" id="MatchCode" />
                <input name="MatchRate" type="hidden" id="MatchRate" />
                <input name="MatchTeam" type="hidden" id="MatchTeam" />

                <input name="ServerTime_Select" type="hidden" id="ServerTime_Select" />
                <input name="ServerTime_Submit" type="hidden" id="ServerTime_Submit" />

                <input name="DateTimeP" type="hidden" id="DateTimeP" value="1572429898000" />
                <input name="ServerTime_Formatted" type="hidden" id="ServerTime_Formatted" />

                <input name="TeamKRate" type="hidden" id="TeamKRate" />
                <input name="TeamLRate" type="hidden" id="TeamLRate" />
                <input name="BetTeamindex" type="hidden" id="BetTeamindex" />

                <input name="SubmitTimeValue" type="hidden" id="SubmitTimeValue" value="" />

                <input name="MatchBetChk" type="hidden" id="MatchBetChk" value="" />
                <input name="SessionBetChk" type="hidden" id="SessionBetChk" value="" />

                <input name="UserType" id="UserType" type="hidden" value={UserType} />
                <input name="UserName" id="UserName" type="hidden" value={UserName} />

                <input name="MatchMinAmount" type="hidden" id="MatchMinAmount" value="100" />
                <input name="MatchMaxAmount" type="hidden" id="MatchMaxAmount" value="10000" />

                <input name="AmountTime" type="hidden" id="AmountTime" value="" />
                <input name="AmountTimeChk" type="hidden" id="AmountTimeChk" value="" />

                <div className="right-bet-inner">
                    <div id="MatchUnMatchBetaData">
                        <div id="accountView" role="main">
                            <span id="msg_error"></span>
                            <span id="errmsg"></span>
                            <div className="balance-panel-body">
                                <div className="table-responsive sports-tabel">
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr className="heading_user_table" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white' }}>
                                                <td>Team</td>
                                                <td>Mode</td>
                                                <td>Rate</td>
                                                <td>Amount</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {BBBBets.map((row, index) => (
                                                <tr className="heading_user_table">
                                                    <td>{row.Team}</td>
                                                    <td>{row.Mode === "K" ? "L" : "K"}</td>
                                                    <td>{row.Rate}</td>
                                                    <td>{row.Amount}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>

            <div id="betSidenav" className="betsidenav">
                <a className="closebtn">x</a>
                <section className="right-bet-content">
                    <div className="betSlipBox" id="betSlipBoxSession" style={{ display: 'none' }}>
                        <div className="betBox bet-slip-box">
                            <span id="msg_error"></span>
                            <span id="errmsg"></span>
                            <div className="lds-dual-ring  loader" style={{ display: 'none' }}></div>
                            <div className="bet-box_inner" id="betBoxColor" style={{ backgroundColor: 'rgb(250, 169, 186)' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', margin: '5px', alignItems: 'center' }}>
                                    <div style={{ fontWeight: '700' }} id="DisplayBhavName"></div>
                                </div>
                                <div className="inner-bet-section">
                                    <div className="oddds-stake-box" style={{ marginBottom: '10px' }}>
                                        <div className="items odds">
                                            <div className="stack_input_field numbers-row">
                                                <input disabled="" type="number" className="calProfitLoss odds-input form-control  CommanBtn" value="" id="Rate1_Odds" />
                                                <div className="inc plus_btn">
                                                    <span className="plus_btns">+</span>
                                                    <div className="quantity-button quantity-up">
                                                        <i className="fas fa-plus"></i>
                                                    </div>
                                                </div>
                                                <div className="dec plus_btn">
                                                    <span className="minus_btns">-</span>
                                                    <div className="quantity-button quantity-down">
                                                        <i className="fas fa-minus"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="items stake" id=" ">
                                            <div className="stack_input_field numbers-row">
                                                <input type="number" pattern="[0-9]*" step="1" id="MatchAmount" className="calProfitLoss stake-input form-control  CommanBtn" value="0" />

                                                <div className="inc plus_btn">
                                                    <span className="plus_btns">+</span>
                                                    <div className="quantity-button quantity-up">
                                                        <i className="fas fa-plus"></i>
                                                    </div>
                                                </div>
                                                <div className="dec plus_btn">
                                                    <span className="minus_btns">-</span>
                                                    <div className="quantity-button quantity-down">
                                                        <i className="fas fa-minus"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bet-btns">
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="100" onClick={() => { document.getElementById("MatchAmount").value = 100; }}>100</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="200" onClick={() => { document.getElementById("MatchAmount").value = 200; }}>200</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="500" onClick={() => { document.getElementById("MatchAmount").value = 500; }}>500</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="1000" onClick={() => { document.getElementById("MatchAmount").value = 1000; }}>1K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="2000" onClick={() => { document.getElementById("MatchAmount").value = 2000; }}>2K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="3000" onClick={() => { document.getElementById("MatchAmount").value = 3000; }}>3K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="5000" onClick={() => { document.getElementById("MatchAmount").value = 5000; }}>5K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="10000" onClick={() => { document.getElementById("MatchAmount").value = 10000; }}>10K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" " type="button">Clear</button>
                                        </div>
                                    </div>
                                    <div className="bet-box-footer">
                                        <button className="btn cancle-bet" type="button" onClick={handleCancelClick}>Cancel</button>
                                        <button className="btn place-bet" type="button" id="cmdDone" onClick={handlePlaceBet}>Place Bet</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="overlay_mobile in"></div>

                </section>
            </div>

            <div className="betSlipBox mobile-bet-box" style={{ position: 'fixed', bottom: '0px', zIndex: '999', display: 'none' }} id="betSlipBoxSessionMob">
                <div className="betBox bet-slip-box">
                    <span id="msg_error"></span>
                    <span id="errmsg"></span>
                    <div className="lds-dual-ring  loader" style={{ display: 'none' }}></div>
                    <div className="bet-box_inner bet-box-inner-mobile" id="betBoxColorMob" style={{ backgroundColor: 'rgb(250, 169, 186)' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', margin: '5px', alignItems: 'center' }}>
                            <div style={{ fontWeight: '700' }} id="DisplayBhavNameMob">45 over run SA</div>
                        </div>
                        <div className="inner-bet-section">
                            <div className="oddds-stake-box" style={{ marginBottom: '10px' }}>
                                <div className="items odds">
                                    <div className="stack_input_field numbers-row">
                                        <input type="number" pattern="[0-9]*" disabled="" className="calProfitLoss odds-input form-control  CommanBtn" value="188" id="Rate1_OddsMob" />
                                    </div>
                                </div>
                                <div className="items stake">
                                    <div className="stack_input_field numbers-row">
                                        <input type="number" pattern="[0-9]*" step="1" id="MatchAmountMob" className="calProfitLoss stake-input form-control  CommanBtn" />
                                        <div className="inc plus_btn">
                                            <span className="plus_btns">+</span>
                                            <div className="quantity-button quantity-up">
                                                <i className="fas fa-plus"></i>
                                            </div>
                                        </div>
                                        <div className="dec plus_btn">
                                            <span className="minus_btns">-</span>
                                            <div className="quantity-button quantity-down">
                                                <i className="fas fa-minus"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bet-btns">
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="100" onClick={() => { document.getElementById("MatchAmountMob").value = 100; }}>100</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="200" onClick={() => { document.getElementById("MatchAmountMob").value = 200; }}>200</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="500" onClick={() => { document.getElementById("MatchAmountMob").value = 500; }}>500</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="1000" onClick={() => { document.getElementById("MatchAmountMob").value = 1000; }}>1K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="2000" onClick={() => { document.getElementById("MatchAmountMob").value = 2000; }}>2K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="3000" onClick={() => { document.getElementById("MatchAmountMob").value = 3000; }}>3K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="5000" onClick={() => { document.getElementById("MatchAmountMob").value = 5000; }}>5K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="10000" onClick={() => { document.getElementById("MatchAmountMob").value = 10000; }}>10K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="20000" onClick={() => { document.getElementById("MatchAmountMob").value = 20000; }}>20K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="25000" onClick={() => { document.getElementById("MatchAmountMob").value = 25000; }}>25K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="50000" onClick={() => { document.getElementById("MatchAmountMob").value = 50000; }}>50K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" " type="button">Clear</button>
                                </div>
                            </div>
                            <div className="bet-box-footer">
                                <button className="btn cancle-bet" type="button" onClick={handleCancelClick}>Cancel</button>
                                <button className="btn place-bet" type="button" id="cmdDoneMob" onClick={handlePlaceBet}>Place Bet</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BBB;
